module.exports = __webpack_public_path__ + "img/ciaz-plata-metalico.e779d3ef.png";